const outlinedCls = 'mw-chips--outlined';

export function mdChipsProvider($provide) {
    'ngInject';

    let chipsContainerInstance = 0;

    // add additional function to md-chips
    $provide.decorator('mdChipsDirective', mdChipsDirectiveOverride);

    mdChipsDirectiveOverride.$inject = ['$delegate', '$parse', '$window'];

    function mdChipsDirectiveOverride($delegate, $parse, $window) {
        const directive = $delegate[0];
        // need to append to base compile function
        const compile = directive.compile;
        // add our custom attribute to the directive's scope
        angular.extend(directive.scope, {
            draggable: '@?isDraggable',
            onDropTargetDrop: '&',
            onChipDrop: '&',
            label: '@?label',
            maxHeight: '@?maxHeight',
            ngRequired: '@?ngRequired'
        });

        // recompile directive and add our class to the virtual repeat container
        directive.compile = function (element, attr) {
            let chipsContainerId = `md-chip-draggable-container--${chipsContainerInstance++}`;
            let template = compile.apply(this, arguments);

            // from https://github.com/angular/material/blob/master/src/components/chips/js/chipsDirective.js#L189
            let mdChipsTemplate = `
                <label class="mw-chips--outlined-label" ng-if="$mdChipsCtrl.label" ng-bind="$mdChipsCtrl.label" ng-class="{'md-required': $mdChipsCtrl.ngRequired}"></label>
                <div class="mw-chip-outlined-container">
                    <div class="mw-chip-outlined-scroll" ng-style="{'max-height': $mdChipsCtrl.maxHeight}">
                        <span ng-if="$mdChipsCtrl.readonly" class="md-visually-hidden">
                            {{$mdChipsCtrl.containerHint}}
                        </span>
                        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"
                            index="{{$index}}" aria-label="{{$mdChipsCtrl.deleteHint}}"
                            ng-class="{'md-focused': $mdChipsCtrl.selectedChip == $index, 'md-readonly': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">
                            <div class="md-chip-content"
                                tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"
                                id="{{$mdChipsCtrl.contentIdFor($index)}}"
                                role="option"
                                aria-selected="{{$mdChipsCtrl.selectedChip === $index}}"
                                aria-posinset="{{$index}}"
                                ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"
                                ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"
                                md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>
                            <div ng-if="$mdChipsCtrl.isRemovable()"
                                class="md-chip-remove-container"
                                tabindex="-1"
                                md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>
                        </md-chip>
                        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">
                            <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>
                        </div>
                    </div>
                </div>`;

            attr.maxHeight = attr.maxHeight ? (attr.maxHeight - 50) + 'px' : 'none';
            // make whole md-chips click focus the input
            element.on('click', function (event) {
                if (!(event.target.tagName === 'MD-CHIP'
                    || event.target.tagName === 'MD-CHIP-TEMPLATE'
                    || event.target.tagName === 'md-icon'
                    || event.target.classList.contains('md-chip-content')
                    || event.target.classList.contains('md-chip-remove'))) {
                    angular.element(this).find('input').focus();
                }

            });

            const scope = element.scope();

            if (attr.isDraggable) {
                mdChipsTemplate = `
                    <label class="mw-chips--outlined-label" ng-if="$mdChipsCtrl.label" ng-bind="$mdChipsCtrl.label" ng-class="{'md-required': $mdChipsCtrl.ngRequired}"></label>
                    <div id="${chipsContainerId}" class="md-chip-draggable-container"
                        ui-on-drop="$mdChipsCtrl.dropTargetDropHandler($event, $data)"
                        drop-channel="{{$mdChipsCtrl.draggable}}">
                        <div class="mw-chip-outlined-scroll" ng-style="{'max-height': $mdChipsCtrl.maxHeight}">
                            <md-chip ng-repeat="$chip in $mdChipsCtrl.items"
                                index="{{$index}}"
                                ng-class="{'md-focused': $mdChipsCtrl.selectedChip == $index, 'md-readonly': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}"
                                ui-draggable="true"
                                drag="{chip: $chip, chipSourceContainerId: '${chipsContainerId}'}"
                                drag-channel="{{$mdChipsCtrl.draggable}}"
                                on-drop-success="$mdChipsCtrl.chipDropHandler($event, {chip: $chip, chipSourceContainerId: '${chipsContainerId}', channel: $mdChipsCtrl.draggable})">
                                <div class="md-chip-content"
                                    tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"
                                    id="{{$mdChipsCtrl.contentIdFor($index)}}"
                                    role="option"
                                    aria-selected="{{$mdChipsCtrl.selectedChip == $index}}"
                                    aria-posinset="{{$index}}"
                                    ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"
                                    ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"
                                    md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>
                                <div ng-if="$mdChipsCtrl.isRemovable()"
                                    class="md-chip-remove-container"
                                    tabindex="-1"
                                    md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>
                            </md-chip>
                            <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">
                                <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>
                            </div>
                        </div>
                    </div>`;
            }

            if (attr.isDraggable || element.hasClass(outlinedCls)) {
                element.find('md-chips-wrap').empty();
                element.find('md-chips-wrap').append(mdChipsTemplate);
            }

            // recompile the template
            return function (scope, element, attrs, controllers) {
                let mdChipsCtrl = controllers[0];

                mdChipsCtrl.dropTargetDropHandler = ($event, data) => {
                    if (attrs.onDropTargetDrop) {
                        mdChipsCtrl.onDropTargetDrop({$event, data});
                    } else {
                        if (mdChipsCtrl.items.indexOf(data.chip) === -1) {
                            // Add chip to items array for the dropped chips container
                            mdChipsCtrl.items.push(data.chip);

                            // Remove the chip from the source chips container
                            let srcContainerChipsCtrl = angular.element($window.document.getElementById(data.chipSourceContainerId)).scope().$mdChipsCtrl;
                            srcContainerChipsCtrl.removeChip(srcContainerChipsCtrl.items.indexOf(data.chip));

                            // Give focus to the chips container that the chip was dropped in
                            angular.element($event.target.closest('.md-chip-draggable-container')).find('input').focus();
                        }
                    }
                };

                mdChipsCtrl.chipDropHandler = ($event, data) => {
                    if (attrs.onChipDrop) {
                        mdChipsCtrl.onChipDrop({$event, data});
                    }
                };

                template.apply(this, arguments);
            };
        };

        return $delegate;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/chips/md-chips-provider.config.ts